import { createContext, useContext } from 'react';
import { OptionsCalculatorActionsContextType } from './OptionsCalculatorContextProvider';

export const OptionsCalculatorActionsContext =
  createContext<OptionsCalculatorActionsContextType | null>(null);

export const useOptionsCalculatorActions =
  (): OptionsCalculatorActionsContextType => {
    const context = useContext(OptionsCalculatorActionsContext);
    if (context == null) {
      throw new Error(
        'useOptionsCalculatorActions must be used within OptionsCalculatorProvider',
      );
    }
    return context;
  };
